var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,8.635 C6.449,8.635 6,8.186 6,7.635 C6,7.084 6.449,6.635 7,6.635 C7.551,6.635 8,7.084 8,7.635 C8,8.186 7.551,8.635 7,8.635               M7,4.635 C5.343,4.635 4,5.978 4,7.635 C4,9.292 5.343,10.635 7,10.635 C8.657,10.635 10,9.292 10,7.635 C10,5.978 8.657,4.635 7,4.635               M7,17 C7,17 2,10 2,7 C2,4.243 4.243,2 7,2 C9.757,2 12,4.243 12,7 C12,10 7,17 7,17               M7,0 C3.134,0 0,3.134 0,7 C0,10.866 7,20 7,20 C7,20 14,10.866 14,7 C14,3.134 10.866,0 7,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.d5465f5ee01759b06233e45ba9fa81d8.svg";
export { ForwardRef as ReactComponent };